// SmartDocumentViewer Types

export interface SmartDocumentViewerProps {
  /** Signed URL or blob URL of the document */
  url: string;
  /** Document title for accessibility */
  title: string;
  /** MIME type of the document */
  mimeType: string;
  /** Optional: Raw file data (Blob, File, or ArrayBuffer) - prioritized over url for PDFs */
  fileData?: Blob | File | ArrayBuffer;
  /** Optional: Additional class name */
  className?: string;
  /** Optional: Show floating controls (default: true) */
  showControls?: boolean;
  /** Optional: Called when document loads successfully */
  onLoad?: () => void;
  /** Optional: Called on error */
  onError?: (error: string) => void;
}

export interface SmartViewerControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  onRotate: () => void;
  canZoomIn: boolean;
  canZoomOut: boolean;
}

export interface PDFContentProps {
  url: string;
  /** Optional: Raw file data - prioritized over url */
  fileData?: Blob | File | ArrayBuffer;
  rotation: number;
  onLoadSuccess: (numPages: number) => void;
  onLoadError: (error: string) => void;
  containerWidth: number;
}

export interface ImageContentProps {
  url: string;
  title: string;
  rotation: number;
  onLoad: () => void;
  onError: (error: string) => void;
}

export type ContentType = 'pdf' | 'image' | 'unsupported';

export function getContentType(mimeType: string): ContentType {
  if (mimeType === 'application/pdf') return 'pdf';
  if (mimeType.startsWith('image/')) return 'image';
  return 'unsupported';
}

// Zoom constraints
export const ZOOM_MIN = 0.5;
export const ZOOM_MAX = 4;
export const ZOOM_STEP = 0.3;
